import React, { useMemo } from 'react';
import { useInput } from 'react-admin';
import {
  Select,
  MenuItem,
  ListSubheader,
  InputLabel,
  FormControl,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  PhaseInterface,
  PhaseStructureTypeEnum,
} from '@vatos-pas/common';

type ReceivablePhaseSelectInputProps = {
  source: string;
  label?: string;
  choices?: PhaseInterface[];
};

const useStyles = makeStyles({
  formControl: {
    minWidth: 160,
    marginBottom: 8,
  },
});

export const ReceivablePhaseSelectInput: React.FC<
  ReceivablePhaseSelectInputProps
> = props => {
  const { choices = [], label = 'Phase' } = props;
  const classes = useStyles();
  const { input } = useInput(props);

  const phaseGroups = useMemo(
    () =>
      [
        { header: 'Drywall', type: PhaseStructureTypeEnum.Drywall },
        { header: 'Drywall and Paint', type: PhaseStructureTypeEnum.DrywallAndPaint },
      ].map(group => ({
        ...group,
        phases: choices
          .filter(c => c.phaseStructureType === group.type)
          .sort((a, b) => a.priority - b.priority),
      })),
    [choices],
  );

  return (
    <FormControl variant="filled" className={classes.formControl} fullWidth>
      <InputLabel shrink>{label}</InputLabel>
      <Select
        value={input.value || ''}
        onChange={e => input.onChange(e.target.value)}
        displayEmpty
        variant="filled"
        margin="dense"
        fullWidth
      >
        <MenuItem value="">All</MenuItem>

        {phaseGroups.flatMap(group =>
          group.phases.length === 0
            ? []
            : [
                <ListSubheader key={`${group.type}-header`}>
                  {group.header}
                </ListSubheader>,
                ...group.phases.map(phase => (
                  <MenuItem key={phase.id} value={phase.id}>
                    {phase.name}
                  </MenuItem>
                )),
              ],
        )}
      </Select>
    </FormControl>
  );
};

export default ReceivablePhaseSelectInput;
